module.exports = __webpack_public_path__ + "img/mono-rounded.94f40017.svg";